export default __webpack_public_path__ + "static/media/overload.9277e934.png";